import React from "react";
import classNames from "classnames";

import IDHFormattedMessage from "../IDHFormattedMessage/IDHFormattedMessage";

import "./Tabs.scss";

interface Props {
  className?: string;
  titleId?: string;
  disabled?: boolean;
  underlined?: boolean;
  bigTitle?: boolean;
  children: React.ReactNode;
  useStylingForScroller?: boolean;
}

function Tabs(props: Props) {
  const {
    className,
    children,
    titleId,
    disabled,
    underlined,
    bigTitle,
    useStylingForScroller,
  } = props;
  return (
    <div
      className={classNames("tabs", className, {
        "tabs--disabled": disabled,
        "tabs--underlined": underlined,
        "tabs--scroller": useStylingForScroller,
      })}
    >
      {titleId && (
        <div
          className={classNames("tabs__title", {
            "tabs__title--big": bigTitle,
          })}
        >
          <IDHFormattedMessage id="ws_not_used" defaultMessage="Not used" />
        </div>
      )}
      <ul className="tabs__content">{children}</ul>
    </div>
  );
}

export default Tabs;
